import { useContext, useEffect, useState } from "react";
import { LocaleContext } from "../../contexts/LocaleContext";
import { useParams } from "react-router-dom";
import { toast } from "../../services/toastService";
import { bookingService } from "../../services/bookingService";
import Loading from "../../components/common/Loading";

const BookingDetails = () => {
  const { t,lang } = useContext(LocaleContext);
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    getDeatil();
  },[]);

  const getDeatil = async () => {
    try {
      setLoading(true);
      const result = await bookingService.getDetail(id);
      if(!result.isSuccess)
      {
        toast.error(t("anErrorOccurredPleaseTryAgainLater"));
        console.log(result);
        return;
      }
      setData(result.value);
      console.log(result);
    } catch (error) {
      toast.error(t("anErrorOccurredPleaseTryAgainLater"));
      console.log(error);
    }
    finally{
      setLoading(false);
    }
  };
  if(loading) return <Loading />

  return (
    <section className="section-booking-details">
      <div className="default-heading">{t("bookings")}</div>
      <div className="my-card">
        <div className="my-card-header">{t("bookingDetails")}</div>
        <div className="my-card-dark">
          <div className="row">
            <div className="col-12 col-md-3 ">
              <div className="my-heading border-right-white border-bottom-white flex-center">
                {t("tripsApp")}
              </div>
            </div>
            <div className="col-12 col-md-9">
              <div className="my-dark-card-items">
                <div className="my-dark-card-item">
                  <strong>{t("bookingNumber")}</strong>
                  <span>{data?.code}</span>
                </div>
                <div className="my-dark-card-item">
                  <strong>{t("bookingDate")}</strong>
                  <span>{data?.bookingDate?.toDate()}</span>
                </div>
                <div className="my-dark-card-item">
                  <strong>{t("status")}</strong>
                  <span>{t(data?.status)}</span>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="my-heading border-right-white  flex-center">
                {t("bookingDetails")}
              </div>
            </div>
            <div className="col-12 col-md-9">
              <div className="my-dark-card-items border-0">
                <div className="my-dark-card-item">
                  <strong>{t("noOfPeople")}</strong>
                  <span>
                    {data?.noOfPeople} {t("people")}
                  </span>
                </div>
                <div className="my-dark-card-item">
                  <strong>
                    {t("noOf")} {t(data?.unit)}
                  </strong>
                  <span>
                    {data?.unitNumber} {t(data?.unit)}
                  </span>
                </div>
                <div className="my-dark-card-item">
                  <strong>{t("startTime")}</strong>
                  <span>{data?.startTime?.toTime(lang)}</span>
                </div>
                <div className="my-dark-card-item">
                  <strong>{t("endTime")}</strong>
                  <span>
                    {data?.startTime?.toTime(lang, data?.unitNumber ?? 0)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="my-card-dark mt-3">
          <div className="my-card-header">{t("costDetails")}</div>
          <div className="row">
            <div className="col-12 col-md-3">
              <div className="box-3d">
                <div className="box-3d-heading">{t("packageCost")}</div>
                <div className="box-3d-item">
                  <bold>{t("noCommission")}</bold>
                  <span>
                    {data?.noCommission} {t("riyal")}
                  </span>
                </div>
                <div className="box-3d-item">
                  <bold>{t("withCommission")}</bold>
                  <span>
                    {data?.totalCost} {t("riyal")}
                  </span>
                </div>
                <div className="box-3d-item">
                  <bold>{t("serviceFeesPackage")} :</bold>
                  <span>
                    {data?.appCommission} {t("riyal")}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="box-3d">
                <div className="box-3d-heading">{t("addOnsCost")}</div>
                <div className="box-3d-item">
                  <bold>{t("total")}</bold>
                  <span>
                    {data?.addonCost} {t("riyal")}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="box-3d">
                <div className="box-3d-heading">{t("appCommission")}</div>
                <div className="box-3d-item justify-content-center">
                  <span>
                    {data?.appCommission} {t("riyal")}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="box-3d">
                <div className="box-3d-heading">{t("providerCommission")}</div>
                <div className="box-3d-item justify-content-center">
                  {/* no commission means provider cost */}
                  <span>
                    {data?.noCommission} {t("riyal")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="my-card-dark mt-3">
          <div className="my-card-header d-flex justify-content-center m-0">
            {t("totalTripCost")} {data?.totalCost} {t("riyal")}
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12 col-md-6">
            <div className="my-card-dark mt-3">
              <div className="my-card-header">{t("clientInformation")}</div>
              <div className="bordered-item d-none">
                <b>{t("id")}</b> : {data?.customer?.id}
              </div>
              <div className="bordered-item">
                <b>{t("name")}</b> : {data?.customer?.name}
              </div>
              <div className="bordered-item">
                {t("userName")} : {data?.customer?.userName}
              </div>
              <div className="bordered-item">
                {t("email")} : {data?.customer?.email}
              </div>
              <div className="bordered-item">
                {t("city")} :  {data?.customer?.city[lang]}
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="my-card-dark mt-3">
              <div className="my-card-header">{t("providerInformation")}</div>
              <div className="bordered-item d-none">
                <b>{t("id")}</b> :  {data?.provider?.id}
              </div>
              <div className="bordered-item">
                <b>{t("name")}</b> : {data?.provider?.name}
              </div>
              <div className="bordered-item">
                {t("userName")} : {data?.provider?.userName}
              </div>
              <div className="bordered-item">
                {t("email")} : {data?.provider?.email}
              </div>
              <div className="bordered-item">
                {t("city")} :  {data?.provider?.city[lang]}
              </div>
            </div>
          </div>
        </div>
        <div className="my-card-dark mt-3">
          <div className="row">
            <div className="col-12 col-md-3">
              <div className="my-heading border-right-white flex-center">
                {t("bankInformation")}
              </div>
            </div>
            <div className="col-12 col-md-9 h-100">
              <div className="my-dark-card-items">
                <div className="my-dark-card-item">
                  <strong>{t("bankName")}</strong>
                  <span>{data?.provider?.bankName[lang]}</span>
                </div>
                <div className="my-dark-card-item">
                  <strong>{t("ibanNo")}</strong>
                  <span>{data?.provider?.iban}</span>
                </div>
              </div>
              <div className="my-dark-card-items border-0">
                <div className="my-dark-card-item">
                  <strong>{t("total")}</strong>
                  <span>
                    {data?.provider?.balance ?? 0} {t("riyal")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="my-card-dark mt-3">
          <div className="row">
            <div className="col-12 col-md-3">
              <div className="my-heading border-right-white flex-center">
                {t("tripInformation")}
              </div>
            </div>
            <div className="col-12 col-md-9 h-100">
              <div className="my-dark-card-items">
                <div className="my-dark-card-item">
                  <strong>{t("name")}</strong>
                  <span>{data?.trip?.name[lang]}</span>
                </div>
                <div className="my-dark-card-item">
                  <strong>{t("maxNoOfPeople")}</strong>
                  <span>{data?.trip?.maxPersons}</span>
                </div>
              </div>
              <div className="my-dark-card-items border-0">
                <div className="my-dark-card-item">
                  <strong>{t("total")}</strong>
                  <span>
                    {data?.totalCost ?? 0} {t("riyal")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {data?.addons && data?.addons?.length > 0 && (
          <div className="my-card-dark mt-3">
            <div className="row">
              <div className="col-12 col-md-3">
                <div className="my-heading border-right-white flex-center">
                  {t("selectedAddOns")}
                </div>
              </div>
              <div className="col-12 col-md-9 h-100">
                <div className="my-dark-card-items">
                  {data.addons.map((addon,index) => (
                    <div className="my-dark-card-item" key={index}>
                      <strong>{addon.name[lang]} ({addon?.quantity})</strong>
                      <span>
                        {t("price")} : {addon.price} {t("riyal")} 
                      </span>
                    </div>
                  ))}
                </div>
                <div
                  className="my-dark-card-items border-0"
                  style={{ height: "68.19px" }}
                >
                   <div className="my-dark-card-item">
                      <strong>{t("total")}</strong>
                      <span>
                       {data?.addonCost}{" "}
                        {t("riyal")}
                      </span>
                    </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default BookingDetails;
